<nav class="pagination-row" aria-label="Members result pagination">
  <div aria-live="polite">Page {{currentPage}}</div>
    <a href="#paginationPrevLink" class="navigation-button" id="paginationPrevLink" [class.hidden]="currentPage === 1" (click)="onPrevButton($event)" aria-label="Previous Page">
      <span class="arrow arrow-left" [class.arrow-disabled]="currentPage === 1"></span>
      Prev
    </a>
    <ng-container *ngFor="let number of clickablePageNum; let i = index">
      <span *ngIf="number === ''" class="ellupsis">...</span>
      
      <a [href]="'paginationLink' + number"
        [attr.aria-label]="number === numOfPages ? 'Last page, page ' + number : 'page ' + number"
        class="navigation-button"
        *ngIf="number !== ''"
        (click)="onChangeNum($event, number)"
        [class.current]="currentPage === number"
        [attr.aria-current]="currentPage === number ? 'page' : null"
        [attr.id]="'paginationLink' + number"
        >{{ number }}</a
      >
    </ng-container>
    <a href="#paginationNextLink" class="navigation-button" id="paginationNextLink" [class.hidden]="currentPage === numOfPages" (click)="onNextButton($event)" aria-label="Next Page">
      Next
      <span class="arrow arrow-right" [class.arrow-disabled]="currentPage === numOfPages"></span>
    </a>
  </nav>
